module.exports = __webpack_public_path__ + "img/topic1-1.f41c8a7a.png";